import React, { FC } from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeProps {
  value: string;
  size?: number;
  className?: string;
}

/**
 * QR Code component using qrcode.react library.
 * Generates a scannable QR code from the input value.
 */
const QRCode: FC<QRCodeProps> = ({ value, size = 200, className = '' }) => {
  return (
    <div className={`inline-block ${className}`}>
      <QRCodeSVG
        value={value}
        size={size}
        level="M" // Error correction level: L, M, Q, H
        includeMargin={true}
        bgColor="#ffffff"
        fgColor="#1a1a1a"
      />
    </div>
  );
};

export default QRCode;
